import React from 'react';

import pciIcon from '../../../styles/assets/images/purekitPage/PCI.svg';
import ccpaIcon from '../../../styles/assets/images/purekitPage/soc-logo.png';
import gdprIcon from '../../../styles/assets/images/purekitPage/GDPR.svg';
import hipaaIcon from '../../../styles/assets/images/purekitPage/HIPAA.svg';

const Standards: React.FC = () => {
	return (
		<section className="standards">
			<div className="wrapper">
				<div className="left-side">
					<h3 className="headline">Comply with Acts and Laws</h3>
					<p className="text">
						Virgil Security builds developer toolkits that solve business problems by encrypting
						data and therefore lessening legal and compliance liability.
					</p>
				</div>
				<div className="right-side">
					<ul className="certificate">
						<li className="certificate-item">
							<img src={pciIcon} alt="PCI DSS" className="certificate-icon" />
							<div className="text-container">
								<h4 className="certificate-headline">PCI DSS</h4>
								<p className="certificate-text">Payment Card Industry Data Security Standard</p>
							</div>
						</li>
						<li className="certificate-item">
							<img src={ccpaIcon} alt="CCPA" className="certificate-icon" />
							<div className="text-container">
								<h4 className="certificate-headline">CCPA</h4>
								<p className="certificate-text">California Consumer Privacy Act</p>
							</div>
						</li>
						<li className="certificate-item">
							<img src={gdprIcon} alt="GDPR" className="certificate-icon" />
							<div className="text-container">
								<h4 className="certificate-headline">GDPR</h4>
								<p className="certificate-text">General Data Protection Regulation</p>
							</div>
						</li>
						<li className="certificate-item">
							<img src={hipaaIcon} alt="HIPAA" className="certificate-icon" />
							<div className="text-container">
								<h4 className="certificate-headline">HIPAA</h4>
								<p className="certificate-text">
									Health Insurance Portability and Accountability Act
								</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</section>
	);
};

export default Standards;
